const PAYMENT_GRACE_KEY = "payment_recently_completed";
export const GRACE_DURATION_MS = 60_000; // 60 seconds

/**
 * Mark that a payment was just completed successfully.
 * During the grace window, paywall / subscription-lock UI is suppressed
 * so the user is never bounced back to the upgrade screen while the
 * backend is still processing the webhook.
 */
export const setPaymentGrace = () => {
  sessionStorage.setItem(PAYMENT_GRACE_KEY, String(Date.now()));
};

/**
 * Returns true when a payment was completed within the last 60 seconds.
 */
export const isInPaymentGrace = (): boolean => {
  const raw = sessionStorage.getItem(PAYMENT_GRACE_KEY);
  if (!raw) return false;
  const elapsed = Date.now() - Number(raw);
  return elapsed < GRACE_DURATION_MS;
};

/**
 * Clear the grace flag (e.g. after account data confirms active subscription).
 */
export const clearPaymentGrace = () => {
  sessionStorage.removeItem(PAYMENT_GRACE_KEY);
};
